import { EditOutlined, GoogleOutlined, UserOutlined, PhoneOutlined } from "@ant-design/icons";
import { Button, Card, Col, Flex, Typography, Tabs, Divider } from "antd";
import styled from "styled-components";

const { Title } = Typography;

export const ReportDetailsCart = styled(Card)`
  width: 100%;
`;

export const MainTitle = styled.div`
  color: #000;
  gap: 5px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
`;

export const SubItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 5px 0;
`;

export const Spnaline = styled.span`
  text-decoration: line-through;
  margin-left: 10px;
`;

export const SubItemIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const SubItemText = styled.div`
  color: #000;
  align-self: flex-start;
  line-height: 16.94px;
`;

export const EditIcon = styled(EditOutlined)`
  font-size: 20px;
  cursor: pointer;
`;

export const CardWrapper = styled(Card)`
  width: 100%;
`;

export const FlexWrapper = styled.div`
  margin: 16px 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: stretch;
  font-size: 14px;
  gap: 5px;
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  height: 14px;
`;

export const ReportDetailsWrapper = styled(Card)`
  margin-top: 15px;
  margin-bottom: 80px;
`;

export const StyledFlex = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  background: #ffed45;
  padding: 10px;
`;

export const InnerFlex = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 10px;
`;

export const ImageWrapper = styled(Flex)`
  justify-content: space-between;
  flex-wrap: wrap;

  img {
    height: 135px !important;
  }

  @media (max-width: 400px) {
    justify-content: none;
    gap: 15px;

    img {
      height: 100px !important;
    }
  }
`;

export const ImageContainer = styled.div<{ isActive?: boolean }>`
  border: ${({ isActive }) => (isActive ? "1px dotted #9B9B9B" : "none")};
  border-radius: 10px;
  padding: ${({ isActive }) => (isActive ? "16px" : "0px")};
`;

export const StyledUserIcon = styled(UserOutlined)`
  background: #e1effe;
  padding: 5px;
  border-radius: 50%;
`;

export const Timestamp = styled.div`
  color: #9ca3af;
`;

export const StyledGoogleIcon = styled(GoogleOutlined)`
  font-size: 20px;
`;

export const StyledTitle = styled(Title)`
  margin: 0;
  font-weight: 500 !important;
`;

export const ButtonWarper = styled(Button)`
  padding: 0;
  border-radius: 6px;
  border: 1px solid rgb(240, 240, 240) !important;
  box-shadow: none !important;
  padding: 1.3rem;
  cursor: pointer;

  @media (max-width: 992px) {
    padding: 1.3rem 1rem;
    font-size: 14px;
  }

  @media (max-width: 824px) {
    padding: 1.3rem 0.8rem;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    padding: 1.3rem 0.6rem;
    font-size: 11px;
  }
  @media (max-width: 700px) {
    padding: 1.3rem;
    font-size: 14px;
  }
`;

export const StyledLabel = styled.label`
  display: inline;
  cursor: pointer;
  @media (max-width: 865px) {
    display: none;
  }
`;

export const TableContainer = styled.div`
  overflow-x: auto;
`;

export const StyledCol = styled(Col)`
  margin-top: 0;

  @media (max-width: 576px) {
    margin-top: 10px;
  }

  @media (min-width: 576px) and (max-width: 1199px) {
    &:nth-child(3) {
      margin-top: 10px;
    }
  }

  &:first-child {
    margin-top: 0;
  }
`;

export const AddButtonWarper = styled.div`
  width: 99%;
  padding: 8px;
  background-color: #fbfbfb;
  border: 1px solid #f0f0f0;
  margin-top: -16px;
`;

export const TextWrapper = styled.div`
  padding: 20px 0 10px 0;
`;

export const TextBold = styled.span`
  font-weight: 700;
`;

export const TextSubWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  color: #000;
  font-size: 14px;
`;

export const UpdatedText = styled.span`
  color: #000;
  font-weight: 700;
`;

export const StrikethroughText = styled.span`
  text-decoration: line-through;
  margin-right: 8px;
  color: #999;
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 24px;
  }

  .ant-tabs-nav-wrap {
    flex: 1;
  }

  .ant-tabs-extra-content {
    margin-left: 16px;
  }
`;

export const DisabledContent = styled.div<{ isDeleting?: boolean }>`
  opacity: ${(props) => (props.isDeleting ? 0.5 : 1)};
  pointer-events: ${(props) => (props.isDeleting ? "none" : "auto")};
  filter: ${(props) => (props.isDeleting ? "grayscale(100%)" : "none")};
`;

export const StyledStepContent = styled.div`
  margin: 20px 0px;
`;

export const ActivityDivider = styled(Divider)`
  border-color: #f0f0f0;
  margin: 10px 0;
`;
